export enum ROLES {
  admin = 'ADMIN',
  konkurrent = 'KONKURRENT',
  pjesmarres = 'PJESEMARRES',
  anetarShm = 'ANETAR_KOMISIONI_SHM',
  anetarKlgj = 'ANETAR_KOMISIONI_KLGJ',
  anetarKlp = 'ANETAR_KOMISIONI_KLP',
  anetarAsh = 'ANETAR_KOMISIONI_ASH',
  specialistFv = 'SPECIALIST_FV',
  specialistFF = 'SPECIALIST_FF',
  pedagog = 'PEDAGOG',
  student = 'STUDENT',
  kancelar = 'KANCELAR',
  pergjegjesDepartamentiFv = 'PERGJEGJES_DEPARTAMENTI_FV',
}

export enum StaffROLES {
  anetarShm = 'ANETAR_KOMISIONI_SHM',
  anetarKlgj = 'ANETAR_KOMISIONI_KLGJ',
  anetarKlp = 'ANETAR_KOMISIONI_KLP',
  anetarAsh = 'ANETAR_KOMISIONI_ASH',
  specialistFv = 'SPECIALIST_FV',
  specialistFF = 'SPECIALIST_FF',
  pergjegjesDepartamentiFv = 'PERGJEGJES_DEPARTAMENTI_FV',
  kancelar = 'KANCELAR',
}
